module.exports = __webpack_public_path__ + "static/media/fwas3.1ac7a346.png";